<section class="is-flex is-flex-column has-flex-wrap" *ngFor="let combinedAward of combinedAwards; let last = last">
  <h4 translate="{{combinedAward.awardCategory}}" class="awards-header"></h4>
  <div class="career-award-left-padding">
    <section class="awards-list is-flex has-flex-wrap">
      <div *ngIf="combinedAward.awardCategory === 'agent-profile.awards.career'" class="empty-column"></div>
      <span *ngFor="let award of combinedAward.awards" class="is-flex-column has-flex-align-center award">
        <img [src]="award.url" [alt]="award.name" height="75" appImgLoader/>
        <span class="year">{{ (award.years && award.years.length > 1) ? award.years[0] + ' - ' + award.years[award.years.length -1] : award.year}}</span>
      </span>
    </section>
  </div>
  <div *ngIf="!last" class="line"></div>
</section>
